import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as XLSX from "xlsx";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';
import statesCitiesList from "../../../assets/helperJsonData/state-and-city.json";

import {
} from "../../../store/e-commerce/actions";

import {
  BrandId,
  BrandName,
  CountryOfOrigin,
  TotalCars,
  Status,
  ModelName,
  CarBrand,
  ModelId,
  Year,
} from "./CarVariantsCol";
import * as Yup from "yup";

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  Col,
  Row,
  UncontrolledTooltip,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";
import { getCarBrands } from "store/automobiles/carbrands/actions";
import { useFormik } from "formik";
import CarVariantModel from "./CarVariantModel";
import { addNewCarVariant, addVariantData, deleteAllCarVariants, deleteCarVariant, getCarVariants, updateCarVariant, getCarVariantsPaginated, loadMoreCarVariants, resetCarVariantsPagination, searchCarVariants, searchCarVariantsAll, setCarVariantsSearchFilters, clearCarVariantsSearchFilters } from "store/automobiles/carVariants/actions";
import { getCarModels } from "store/automobiles/carModels/actions";
import CarVariantDetail from "./CarVariantDetail";
import CarVariantPricingModal from "./CarVariantPricingModal";
import CarVariantPricingViewModal from "./CarVariantPricingViewModal";

// Function to generate dynamic data fields array
const generateDataFields = (numOthersFields = 2) => {
  const baseFields = [
    "CarBrand",
    "BrandName",
    "CarModel",
    "ModelName",
    "CarVariant",
    "VariantName",
    "State",
    // "City",
    // "CityCode",
    "Ex-Showroom Price",
    "RTO",
    "Insurance",
  ];

  const othersFields = [];
  for (let i = 1; i <= numOthersFields; i++) {
    othersFields.push(`Others-Key-${i}`, `Others-Value-${i}`);
  }

  return [...baseFields, ...othersFields];
};

function CarVariants() {
  // Define number of "Others" fields
  const numOthersFields = 5; // Adjust this number as needed
  const dataFields = generateDataFields(numOthersFields);

  // Meta title
  document.title = "Car variants | Scrollit";

  // State declarations
  const [modal, setModal] = useState(false);
  const [nestedModal, setNestedModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [variantPricingModal, setVariantPricingModal] = useState(false);
  const [variantPricingViewModal, setVariantPricingViewModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [carVariantsList, setcarVariantsList] = useState([]);
  const [carVariant, setcarVariant] = useState(null);
  const [carVariantData, setcarVariantData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [variantImage, setvariantImage] = useState(null);
  const [itemsPerPage] = useState(50); // Server-side pagination - load 50 items per API call
  const [tablePageSize] = useState(10); // Client-side pagination - show 10 items per table page
  const [usePagination, setUsePagination] = useState(true); // Toggle between paginated and non-paginated
  
  // ✅ NEW: Search and filter states
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [filteredModels, setFilteredModels] = useState([]);
  const [isSearchActive, setIsSearchActive] = useState(false);
  
  const dispatch = useDispatch();
  const history = useNavigate();
  const toggleViewModal = () => setModal1(!modal1);
  const toggleVariantPricingModal = () => setVariantPricingModal(!variantPricingModal);
  const toggleVariantPricingViewModal = () => setVariantPricingViewModal(!variantPricingViewModal);

  const { carBrands, countries, carModels, carVariants, paginatedCarVariants, pagination, isLoading, isLoadingMore, isSearching, searchFilters, searchResults } = useSelector(state => ({
    carBrands: state.CarBrand.carBrands,
    countries: state.CarBrand.countries,
    carModels: state.CarModel.carModels,
    carVariants: state.carVariant.carVariants,
    paginatedCarVariants: state.carVariant.paginatedCarVariants,
    pagination: state.carVariant.pagination,
    isLoading: state.carVariant.isLoading,
    isLoadingMore: state.carVariant.isLoadingMore,
    isSearching: state.carVariant.isSearching,
    searchFilters: state.carVariant.searchFilters,
    searchResults: state.carVariant.searchResults
  }));

  // Form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      modelName: (carVariant && carVariant.modelName) || "",
      carBrand: (carVariant && carVariant.carBrand && carVariant.carBrand._id) || "",
      description: (carVariant && carVariant.description) || "",
      year: (carVariant && carVariant.year) || "",
      status: (carVariant && carVariant.status ? 'Active' : 'InActive') || "",
    },
    validationSchema: Yup.object({
      modelName: Yup.string().required("Please Enter Your Brand Name"),
      carBrand: Yup.string().required("Please Enter Your CarBrand"),
      description: Yup.string().required("Please Enter Your description"),
      year: Yup.string().required("Please Enter Your Year"),
      status: Yup.string().required("Please Enter Your Status")
    }),
    onSubmit: values => {
      if (isEdit) {
        const updcarVariant = new FormData();
        updcarVariant.append("modelName", values["modelName"]);
        updcarVariant.append("description", values["description"]);
        updcarVariant.append("year", values["year"]);
        updcarVariant.append("status", values["status"] === 'Active' ? true : false);
        updcarVariant.append("image", variantImage ? variantImage : "broken!");
        dispatch(updateCarVariant(carVariant._id, values['carBrand'], updcarVariant));
        validation.resetForm();
      } else {
        const newcarVariant = new FormData();
        newcarVariant.append("modelName", values["modelName"]);
        newcarVariant.append("description", values["description"]);
        newcarVariant.append("year", values["year"]);
        newcarVariant.append("status", values["status"] === 'Active' ? true : false);
        newcarVariant.append("image", variantImage ? variantImage : "broken!");
        dispatch(addNewCarVariant(values['carBrand'], newcarVariant));
        validation.resetForm();
      }
      toggle();
    },
    handleError: e => { },
  });

  // Effect hooks
  useEffect(() => {
    dispatch(getCarBrands());
    dispatch(getCarModels());
    
    if (usePagination) {
      // Reset pagination and load first page
      dispatch(resetCarVariantsPagination());
      dispatch(getCarVariantsPaginated(1, itemsPerPage));
    } else {
      // Load all variants (non-paginated)
      if (carVariants && !carVariants.length) {
        dispatch(getCarVariants());
      }
    }
  }, [dispatch, usePagination, itemsPerPage]);

  // ✅ NEW: Filter car models based on selected brand
  useEffect(() => {
    if (selectedBrand && carModels) {
      const filtered = carModels.filter(model => 
        model.carBrand && model.carBrand._id === selectedBrand.value
      );
      setFilteredModels(filtered);
    } else {
      setFilteredModels(carModels || []);
    }
  }, [selectedBrand, carModels]);

  useEffect(() => {
    if (usePagination) {
      setcarVariantsList(paginatedCarVariants);
    } else {
      setcarVariantsList(carVariants);
    }
  }, [carVariants, paginatedCarVariants, usePagination]);

  useEffect(() => {
    if (usePagination) {
      if (!isEmpty(paginatedCarVariants) && !!isEdit) {
        setcarVariantsList(paginatedCarVariants);
        setIsEdit(false);
      }
    } else {
      if (!isEmpty(carVariants) && !!isEdit) {
        setcarVariantsList(carVariants);
        setIsEdit(false);
      }
    }
  }, [carVariants, paginatedCarVariants, isEdit, usePagination]);

  const resizeFile = file => {
    setvariantImage(file);
  }

  const toggle = () => {
    if (modal) {
      setModal(false);
      setcarVariant(null);
    } else {
      setModal(true);
    }
  };

  const handlecarVariantClick = arg => {
    const carVariant = arg;
    setcarVariant(carVariant);
    history(`/add-car-variant/${carVariant._id}`);
    toggle();
  };

  const onClickDelete = (carVariant) => {
    setcarVariant(carVariant);
    setDeleteModal(true);
  };

  const handleDeletecarVariant = () => {
    if (carVariant && carVariant._id) {
      dispatch(deleteCarVariant(carVariant));
      setDeleteModal(false);
    } else {
      dispatch(deleteAllCarVariants());
      setDeleteModal(false);
    }
  };

  const handleAddcarVariantClicks = () => {
    history('/add-car-variant');
  };

  const handlecarVariantDeleteClicks = () => {
    setcarVariant();
    setDeleteModal(true);
  };

  
  const handleDownloadTemplateForVariantPricing = format => {
    console.log("carVariantData", format);
    const book = XLSX.utils.book_new();
    let newArray = [];

    // Generate template data for each state (state-level pricing)
    for (let state in statesCitiesList) {
      let arrayValue = [
        carVariantData?.carModel?.carBrand?._id ?? "",
        carVariantData?.carModel?.carBrand?.brandName ?? "",
        carVariantData?.carModel?._id ?? "",
        carVariantData?.carModel?.modelName ?? "",
        carVariantData?._id ?? "",
        carVariantData?.name ?? "",
        state,
        "", // Ex-Showroom Price
        "", // RTO
        "", // Insurance
        "", // Others-Key-1
        "", // Others-Value-1
        "", // Others-Key-2
        "", // Others-Value-2
        "", // Others-Key-3
        "", // Others-Value-3
        "", // Others-Key-4
        "", // Others-Value-4
        "", // Others-Key-5
        "", // Others-Value-5
      ];
      newArray.push(arrayValue);
    }

    const ws = XLSX.utils.aoa_to_sheet([dataFields, ...newArray]);
    XLSX.utils.book_append_sheet(book, ws, "CarVariant");
    XLSX.writeFile(book, `CarVariant Pricing Template.${format}`);
  };

  const saveVariantPricing = (variantId, tableData, toggle) => {
    dispatch(addVariantData(variantId, tableData, toggle))
  }

  // Pagination control functions
  const handleLoadMore = () => {
    if (pagination.hasNextPage && !isLoadingMore && usePagination) {
      const nextPage = pagination.nextPage || pagination.currentPage + 1;
      dispatch(loadMoreCarVariants(nextPage, itemsPerPage));
    }
  };

  const handleRefresh = () => {
    if (usePagination) {
      dispatch(resetCarVariantsPagination());
      dispatch(getCarVariantsPaginated(1, itemsPerPage));
    } else {
      dispatch(getCarVariants());
    }
  };

  const handleLoadAllRemaining = () => {
    if (!isLoadingMore && pagination.hasNextPage) {
      // Load all remaining pages one by one
      const remainingPages = pagination.totalPages - pagination.currentPage;
      for (let i = 1; i <= remainingPages; i++) {
        const nextPage = pagination.currentPage + i;
        setTimeout(() => {
          dispatch(loadMoreCarVariants(nextPage, itemsPerPage));
        }, i * 100); // Small delay between requests to avoid overwhelming the server
      }
    }
  };

  const togglePaginationMode = () => {
    setUsePagination(!usePagination);
  };

  // ✅ NEW: Search and filter handlers
  const handleSearch = () => {
    const filters = {
      search: searchTerm,
      brandId: selectedBrand?.value || '',
      modelId: selectedModel?.value || '',
      pageNum: 1,
      numProds: itemsPerPage,
      sortBy: 'updatedAt',
      sortOrder: 'desc'
    };
    
    setIsSearchActive(true);
    
    if (usePagination) {
      dispatch(searchCarVariants(filters));
    } else {
      dispatch(searchCarVariantsAll(filters));
    }
  };

  const handleClearSearch = () => {
    setSearchTerm('');
    setSelectedBrand(null);
    setSelectedModel(null);
    setIsSearchActive(false);
    dispatch(clearCarVariantsSearchFilters());
    
    // Reload original data
    if (usePagination) {
      dispatch(resetCarVariantsPagination());
      dispatch(getCarVariantsPaginated(1, itemsPerPage));
    } else {
      dispatch(getCarVariants());
    }
  };

  const handleBrandChange = (selectedOption) => {
    setSelectedBrand(selectedOption);
    setSelectedModel(null); // Reset model when brand changes
  };

  const handleModelChange = (selectedOption) => {
    setSelectedModel(selectedOption);
  };

  // Prepare dropdown options
  const brandOptions = (carBrands || []).map(brand => ({
    value: brand._id,
    label: brand.brandName
  }));

  const modelOptions = (filteredModels || []).map(model => ({
    value: model._id,
    label: model.modelName
  }));

  // Enhanced pagination control functions
  const checkAndLoadMoreData = (requestedPageIndex, currentPageSize) => {
    if (!usePagination) return;
    
    // Calculate total items needed to display the requested page
    const itemsNeeded = (requestedPageIndex + 1) * currentPageSize;
    const currentItemsLoaded = paginatedCarVariants.length;
    
    // If we need more items than we have loaded, and more data is available
    if (itemsNeeded > currentItemsLoaded && pagination.hasNextPage && !isLoadingMore && !isLoading) {
      console.log(`TableContainer pagination: Need ${itemsNeeded} items, have ${currentItemsLoaded}, loading more...`);
      
      // Load the next server page
      const nextPage = pagination.nextPage || pagination.currentPage + 1;
      dispatch(loadMoreCarVariants(nextPage, itemsPerPage));
    }
  };

  // This will be called when TableContainer pagination changes
  const handleTablePaginationChange = (pageIndex, pageSize) => {
    // Check if we need to load more data from server
    checkAndLoadMoreData(pageIndex, pageSize);
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Variant ID',
        accessor: '_id',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <ModelId {...cellProps} />;
        }
      },
      {
        Header: 'Variant Name',
        accessor: 'name',
        filterable: true,
        Cell: (cellProps) => {
          return <ModelName {...cellProps} />;
        }
      },
      {
        Header: 'Car Model',
        accessor: 'carModel.modelName',
        filterable: true,
        Cell: (cellProps) => {
          return <ModelName {...cellProps} />;
        }
      },
      {
        Header: 'Car Brand',
        accessor: 'carModel.carBrand.brandName',
        filterable: true,
        Cell: (cellProps) => {
          return <CarBrand {...cellProps} />;
        }
      },
      {
        Header: 'Status',
        accessor: 'status',
        filterable: true,
        Cell: (cellProps) => {
          return <Status {...cellProps} />;
        }
      },
      {
        Header: 'View Variant Details',
        accessor: 'view',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={e => {
                toggleViewModal();
                setcarVariantData(cellProps.row.original);
              }}
            >
              View Variant Details
            </Button>);
        }
      },
      {
        Header: 'Connect/View Variant Pricing',
        accessor: 'connect',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <>
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded me-2"
              onClick={e => {
                toggleVariantPricingModal();
                setcarVariantData(cellProps.row.original);
              }}
            >
              Connect Pricing
            </Button>
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={e => {
                toggleVariantPricingViewModal();
                setcarVariantData(cellProps.row.original);
              }}
            >
              View List
            </Button>
            </>);
        }
      },
      {
        Header: 'Action',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to={`/edit-car-variant/${cellProps.row.original._id}`}
                className="text-success"
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const carVariantData = cellProps.row.original;
                  onClickDelete(carVariantData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <CarVariantDetail isOpen={modal1} toggle={toggleViewModal} Data={carVariantData} />
      <CarVariantPricingModal
        isOpen={variantPricingModal}
        toggle={toggleVariantPricingModal}
        Data={carVariantData}
        handleDownloadTemplateForVariantPricing={handleDownloadTemplateForVariantPricing}
        saveVariantPricing={saveVariantPricing}
      />
      <CarVariantPricingViewModal
        isOpen={variantPricingViewModal}
        toggle={toggleVariantPricingViewModal}
        Data={carVariantData}
        // tableData={carVariantTableData}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletecarVariant}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Ecommerce" breadcrumbItem="Car Variants" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {/* ✅ NEW: Search and Filter Section */}
                  <div className="mb-4 p-3 bg-light rounded">
                    <Row className="g-3 align-items-end">
                      <Col md={3}>
                        <Label className="form-label">Search by Name</Label>
                        <Input
                          type="text"
                          placeholder="Search variant name..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                        />
                      </Col>
                      <Col md={2}>
                        <Label className="form-label">Filter by Brand</Label>
                        <Select
                          value={selectedBrand}
                          onChange={handleBrandChange}
                          options={brandOptions}
                          isClearable
                          placeholder="Select Brand..."
                        />
                      </Col>
                      <Col md={3}>
                        <Label className="form-label">Filter by Model</Label>
                        <Select
                          value={selectedModel}
                          onChange={handleModelChange}
                          options={modelOptions}
                          isClearable
                          isDisabled={!selectedBrand}
                          placeholder={selectedBrand ? "Select Model..." : "Select Brand first"}
                        />
                      </Col>
                      <Col md={2}>
                        <Button
                          color="primary"
                          onClick={handleSearch}
                          disabled={isSearching || isLoading}
                          className="w-100"
                        >
                          {isSearching ? 'Searching...' : 'Search'}
                        </Button>
                      </Col>
                      <Col md={2}>
                        <Button
                          color="secondary"
                          onClick={handleClearSearch}
                          disabled={isSearching || isLoading}
                          className="w-100"
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>
                    {isSearchActive && (
                      <div className="mt-2 text-info">
                        <small>
                          <i className="bx bx-filter-alt me-1"></i>
                          Filters active: 
                          {searchTerm && ` Name: "${searchTerm}"`}
                          {selectedBrand && ` | Brand: ${selectedBrand.label}`}
                          {selectedModel && ` | Model: ${selectedModel.label}`}
                          {' | '}Results: {pagination.totalRecords}
                        </small>
                      </div>
                    )}
                  </div>

                  {/* Pagination Controls */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-3">
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={togglePaginationMode}
                      >
                        {usePagination ? 'Switch to Full Load' : 'Switch to Pagination'}
                      </Button>
                      <Button
                        color="info"
                        size="sm"
                        onClick={handleRefresh}
                        disabled={isLoading}
                      >
                        {isLoading ? 'Refreshing...' : 'Refresh'}
                      </Button>
                      {usePagination && (
                        <div className="text-muted">
                          <small>
                            Server: {carVariantsList.length} of {pagination.totalRecords} loaded
                            <br />
                            Page {pagination.currentPage} of {pagination.totalPages} 
                            {pagination.hasNextPage ? ` (More available)` : ' (All loaded)'}
                            <br />
                            Table: {tablePageSize} items per page
                          </small>
                        </div>
                      )}
                    </div>
                  </div>

                  <TableContainer
                    columns={columns}
                    data={carVariantsList}
                    isGlobalFilter={true}
                    isAddcarVariantOptions={true}
                    handleAddcarVariantClicks={handleAddcarVariantClicks}
                    handlecarVariantDeleteClicks={handlecarVariantDeleteClicks}
                    customPageSize={tablePageSize}
                    onPaginationChange={usePagination ? handleTablePaginationChange : null}
                  />

                  {/* Load More Button for Pagination */}
                  {usePagination && pagination.hasNextPage && (
                    <div className="text-center mt-3">
                      <div className="d-flex gap-2 justify-content-center">
                        <Button
                          color="primary"
                          onClick={handleLoadMore}
                          disabled={isLoadingMore}
                          size="lg"
                        >
                          {isLoadingMore ? 'Loading More...' : `Load Next ${itemsPerPage}`}
                        </Button>
                        {pagination.totalPages - pagination.currentPage <= 5 && (
                          <Button
                            color="info"
                            onClick={handleLoadAllRemaining}
                            disabled={isLoadingMore}
                            size="lg"
                          >
                            Load All Remaining
                          </Button>
                        )}
                      </div>
                      <div className="mt-2">
                        <small className="text-muted">
                          Page {pagination.nextPage} of {pagination.totalPages} - 
                          {pagination.totalRecords - carVariantsList.length} variants remaining
                        </small>
                      </div>
                    </div>
                  )}

                  {/* No more data message */}
                  {usePagination && !pagination.hasNextPage && carVariantsList.length > 0 && (
                    <div className="text-center mt-3 text-muted">
                      <p>All variants loaded ({pagination.totalRecords} total)</p>
                    </div>
                  )}

                  {/* Loading indicator */}
                  {isLoading && (
                    <div className="text-center mt-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="mt-2 text-muted">Loading car variants...</p>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

CarVariants.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default CarVariants;
